// The three masked fields that need `imask` in the host's package.json. The
// document field needs nothing — it wears doc.js, and lives in registerFire.
import CardInputController from './card_input_controller';
import MoneyInputController from './money_input_controller';
import PhoneInputController from './phone_input_controller';

export function registerFireInputs(application) {
  application.register('card-input', CardInputController);
  application.register('money-input', MoneyInputController);
  application.register('phone-input', PhoneInputController);
}
